import { Group } from './group.model';
import { Tool } from './tool.model';

export class ToolSet {

    public nrOfTools: string;
    public tools: Array<Tool>;
    public parent: Group;

    // TODO: Change the implementation of a tool set so it does not take the properties by only the first element of the set
    get id() {
        return this.tools[0].id;
    }

    get name() {
        return `${this.tools[0].name}  ( x${this.tools.length} )`;
    };

    get mainLine() {
        return this.tools[0].mainLine;
    };

    get line() {
        return this.tools[0].mainLine;
    };

    get owner() {
        return this.tools[0].owner;
    };

    get isAvailable() {

        const checkedElements = this.tools.filter(filteredTools);
        function filteredTools (tool) {
            return tool.isAvailableForManufactoring === true;
        }

        if (checkedElements.length === 0) {
            return 'unavailable';
        } else if (checkedElements.length !== 0 && checkedElements.length !== this.tools.length) {
            return 'partiallyAvailable';
        } else {
            return 'available';
        }
    };

    get children() {
        return this.tools;
    }

    get type() {
        return "toolset";
    }

    get registeredCycles() {
        return this.tools[0].registeredCycles;
    }

    get registeredTime() {
        return this.tools[0].registeredTime;
    }

    constructor(set: any = {}, parent?: Group) {
        this.nrOfTools = set.nrOfTools ? set.nrOfTools : set.size;
        this.mapTools(set.tools || []);
        this.parent = parent;
    }

    private mapTools(tools) {
        this.tools = tools.map(tool => new Tool(tool, this));
    }

    get isInStorage(): boolean {
        let isInStorage = true;
        this.tools.forEach(tool => {
            if (!tool.isInStorage) {
                isInStorage = false;
            }
        })
        return isInStorage;
    }
}
